<template>
  <button class="like-btn" btn="like-btn" id="like-btn">
    <div btn="like-btn">
      <img src="@/assets/img/public/heart.svg" alt="like" btn="like-btn" />
    </div>
    <p btn="like-btn">{{ likeNumber }}</p>
  </button>
</template>

<script>
export default {
  name: "likeButton",
  props: {
    likeNumber: Number,
  },
};
</script>

<style lang="css" scoped>
@import url(@/assets/style/components/likeButton/likeButton.css);
</style>